import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CandlestickChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"candlestick_chart"}/>
}
